import axios from 'axios';
import { mapFrontendTypeToBackend } from '../utils/dataTypeMapping';

const API_URL = `${process.env.VUE_APP_HOST}/api/data`;


let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
    access_token = process.env.VUE_APP_TOKEN;
    if (!access_token) {
        console.log(window.location.hash)
        var queries = window.location.hash.split("access_token=")
        if (queries.length > 1) {
            access_token = queries[1].split("&")[0]
            if (access_token) {
                let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('session-authorization', auth);
            }
        }
    }
}
else {
    access_token = JSON.parse(auth).access_token;
}

let headers = {
    headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
    }
};

export const excelApi = {
  uploadExcel: async (type, file, replace) => {
    const backendType = mapFrontendTypeToBackend(type);
    const formData = new FormData();
    formData.append('file', file);

    let url = type == 'Module/Staff' ?
                        `${API_URL}/upload-module-staff?replace=` + replace
                        :`${API_URL}/upload/${backendType}?replace=` + replace

    const response = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${access_token}`
      }
    });
    return response.data;
  },

  downloadExcel: async (type, filters = {}) => {
    let backendType = mapFrontendTypeToBackend(type);
    if (backendType == 'students') backendType = 'Student';
    const queryString = new URLSearchParams(filters).toString();
    const response = await axios.get(`${API_URL}/download/${backendType}?${queryString}`, {
      responseType: 'blob',
      headers: {
       'Authorization': `Bearer ${access_token}`
      }
    });
    return response.data;
  }
};

